<template>
  <div
    v-if="isOpen"
    class="user-overlay"
  >
    <div class="user-overlay__content">
      <!-- <QButton
        variant="tertiary"
        size="m"
        class="user-overlay__button"
        @click="handleAccountClick"
      >
        <template #icon>
          <v-icon
            name="user"
            height="20"
            width="20"
          />
        </template>
        Личный кабинет
      </QButton> -->

      <QButton
        variant="tertiary"
        size="m"
        class="user-overlay__button"
        @click="handleSignOutClick"
      >
        <template #icon>
          <v-icon
            name="signout"
            height="20"
            width="20"
          />
        </template>
        Выйти
      </QButton>
    </div>
  </div>
</template>

<script setup>
import QButton from '@/components/UI/buttons/QButton.vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';

const router = useRouter();
const store = useStore();

const props = defineProps({
  isOpen: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['close']);

const handleAccountClick = () => {
  router.push({ name: 'account' });
  emit('close');
};

const handleSignOutClick = async () => {
  try {
    await store.dispatch('logout');
  } catch (error) {
    console.error('Error during logout:', error);
  }
  emit('close');
};
</script>

<style lang="scss" scoped>
.user-overlay {
  position: relative;
  z-index: 9999;

  &__content {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 16px;
    background: var(--color-white);
    border-radius: 24px;
    box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.08);
    min-width: 162px;
  }

  &__button {
    width: 100%;
    justify-content: flex-start;
  }
}
</style>
